"use strict";

var $ = jQuery.noConflict();
var $hamburger = $('#hamburger');
var $mobileMenu = $('#mobile-menu-container');
var $window = $(window);
var $header = $('body > header');
var $searchIconContainer = $('.search-icon-container');
var $dropdownSearch = $('.dropdown-search');
$dropdownSearch.slideUp();
var $footerItemHasChild = $('#footer-menu-container li.menu-item-has-children');
$('#footer-menu-container li.menu-item-has-children ul.sub-menu').slideUp();
$(document).ready(function () {
  $hamburger.click(function () {
    $(this).toggleClass('active');
    $mobileMenu.toggleClass('active');
  });
  $('#mobile-menu-container .sub-menu').slideUp(); //$('#mobile-menu-container li.menu-item-has-children > a').after('<span class="dropdown-arrow"></div>');

  $('#mobile-menu-container li.menu-item-has-children .dropdown-arrow').click(function () {
    $this = $(this);

    if ($this.parent().hasClass('showing-children')) {
      $this.parent().find('ul.sub-menu').slideUp();
    } else {
      $this.parent().find('li.menu-item-has-children').removeClass('showing-children');
      $this.parent().children('.sub-menu').slideToggle();
    }

    $this.parent().toggleClass('showing-children');
  });
  $searchIconContainer.click(function () {
    $(this).toggleClass('active');
    $dropdownSearch.toggleClass('active');
    $dropdownSearch.slideToggle();
  });
  $footerItemHasChild.hover(function () {
    // if (!$(this).hasClass('active')) {
    $(this).addClass('active');
    $(this).children('ul.sub-menu').slideDown(); // }
  }, function () {
    $(this).removeClass('active');
    $(this).children('ul.sub-menu').slideUp();
  });
  $window.scroll(function () {
    if ($window.scrollTop() > 0) {
      $header.addClass('fixed');
    } else {
      $header.removeClass('fixed');
    }
  });
  $window.resize(function () {
    if ($window.width() > 767 && $hamburger.hasClass('active')) {
      $hamburger.removeClass('active');
      $mobileMenu.removeClass('active');
    } else {
      $(this).removeClass('active');
      $dropdownSearch.removeClass('active');
      $dropdownSearch.slideUp();
    }
  });
});
$(document).click(function (e) {
  if ($(e.target).closest('#hamburger').length === 0 && $(e.target).closest('#mobile-menu-container').length === 0 && $mobileMenu.hasClass('active')) {
    $hamburger.removeClass('active');
    $mobileMenu.removeClass('active');
  }
});
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    //escape key
    $hamburger.removeClass('active');
    $mobileMenu.removeClass('active');
  }
});